import { Action, createReducer, on } from "@ngrx/store";
import { providersActions } from "../actions";
import _ from "lodash";
import { Provider } from '@core/model/providers';
import { findEntityByCorrespondingId } from '@core/util/transform.util';

export interface State {
  currentProviders: Provider[],
  changedProviders: Provider[]
}

export const initialState: State = {
  currentProviders: [],
  changedProviders: []
}

const providersReducer = createReducer(initialState,
  on(providersActions.providersToDisplayLoaded, (state, action) => {
    let reportChanges = false;
    const currentProviders: Provider[] = _.cloneDeep(state.currentProviders);
    const newProviders: Provider[] = action.providers;
    newProviders.forEach(provider => {
      if (!currentProviders.some(p => p.id === provider.id)) {
        reportChanges = true;
        currentProviders.push(provider);
      }
    })

    if (reportChanges) {
      return {
        ...state,
        currentProviders: currentProviders
      };
    } else {
      return {
        ...state
      };
    }

  }),
  on(providersActions.providersModified, (state, action) => {
    const changedProviders: Provider[] = _.cloneDeep(state.changedProviders);
    const currentProviders: Provider[] = _.cloneDeep(state.currentProviders);
    const providerModified: Provider = action.provider;
    const searchResultChanged = {...findEntityByCorrespondingId(changedProviders, providerModified.id, providerModified.auxId)};
    const searchResultCurrent = {...findEntityByCorrespondingId(currentProviders, providerModified.id, providerModified.auxId)};
    if (searchResultChanged.index !== -1) {
      changedProviders[searchResultChanged.index] = providerModified;
    } else {
      changedProviders.push(providerModified);
    }

    if (searchResultCurrent.index !== -1) {
      currentProviders[searchResultCurrent.index] = providerModified;
    } else {
      currentProviders.push(providerModified);
    }
    return {
      ...state,
      changedProviders: changedProviders,
      currentProviders: currentProviders
    };
  }),
  on(providersActions.providersLoaded, (state, action) => {
    return {
      ...state,
      currentProviders: _.cloneDeep(action.providers) as Provider[],
    };
  }),
  on(providersActions.providersSaved, (state, action) => {
    const currentProviders: Provider[] = _.cloneDeep(state.currentProviders);
    for (const provider of _.cloneDeep(action.providers)) {
      if (provider.auxId) {
        const searchResultCurrent = {...findEntityByCorrespondingId(currentProviders, provider.id, provider.auxId)};
        if (searchResultCurrent.index !== -1) {
          const currentProvider = currentProviders[searchResultCurrent.index];
          currentProvider.auxId = null;
          currentProvider.id = provider.id;
          currentProviders[searchResultCurrent.index] = currentProvider;
        }
      }

    }

    return {
      ...state,
      currentProviders: currentProviders,
      changedProviders: []
    };
  }),
  on(providersActions.datacenterModified, (state, action) => {
    const currentProviders: Provider[] = _.cloneDeep(state.currentProviders);
    const currentIndex = currentProviders.findIndex(p => p.name === action.datacenter.provider);
    if (currentIndex == -1) {
      const providerToDisplay = _.cloneDeep(currentProviders.find(p => p.name === action.datacenter.provider));
      providerToDisplay.isVisible = true;
      currentProviders.push(providerToDisplay)
    }
    return {
      ...state,
      currentProviders: currentProviders,
    };
  }),
  on(providersActions.providerColorChanged, (state, action) => {
    const currentProviders: Provider[] = _.cloneDeep(state.currentProviders);
    const changedProviders: Provider[] = _.cloneDeep(state.changedProviders);
    const providerModified: Provider = action.provider;
    const currentIndex = currentProviders.findIndex(p => (p.id || p.auxId) === (providerModified.id || providerModified.auxId));
    if (currentIndex !== -1) {
      currentProviders[currentIndex].color = providerModified.color;

      // Add to changedProviders if not already there
      if (!changedProviders.some(p => (p.id || p.auxId) === (providerModified.id || providerModified.auxId))) {
        changedProviders.push(currentProviders[currentIndex]);
      } else {
        const changedIndex = changedProviders.findIndex(p => (p.id || p.auxId) === (providerModified.id || providerModified.auxId));
        changedProviders.splice(changedIndex, 1, currentProviders[currentIndex]);
      }
    }

    return {
      ...state,
      currentProviders,
      changedProviders
    };
  }),
  on(providersActions.toggleVisibility, (state, action) => {
    const currentProviders: Provider[] = _.cloneDeep(state.currentProviders);

    for (const provider of action.providers) {
      // Update in currentProviders - check both id and auxId for flexibility
      const currentIndex = currentProviders.findIndex(p =>
        (provider.auxId && p.auxId === provider.auxId) ||
        (!provider.auxId && p.id === provider.id)
      );
      if (currentIndex !== -1) {
        currentProviders[currentIndex].isVisible = action.isVisible;
        currentProviders[currentIndex].hasChanged = false;
      }
    }

    return {
      ...state,
      currentProviders: currentProviders
    };
  }),
  on(providersActions.nukeStore, (state, action) => {
    return {
      ...initialState
    };
  }),
);

export function reducer(state: State | undefined, action: Action): any {
  return providersReducer(state, action);
}
